module.exports = __webpack_public_path__ + "static/img/about5.9f6995e4.png";